import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'bom-badge',
  templateUrl: './badge.component.html',
  styleUrls: ['./badge.component.scss'],
})
export class BadgeComponent implements OnInit {
  @Input()
  text: string;

  @Input()
  size: 'small' | 'large' = 'small';

  @Input()
  type: 'info' | 'success' | 'warning' | 'error' = 'info';

  constructor() {}

  ngOnInit() {}
}
